import React from 'react';
import { useAuth } from '../hooks/useAuth';
import { signOut } from '../lib/supabase';

export default function UnauthorizedOrg() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      <div className="max-w-md text-center space-y-4">
        <h1 className="text-xl font-bold">Acceso no autorizado</h1>
        <p className="text-sm text-muted-foreground">
          Esta app es para clubes y academias. La cuenta {user?.email} no pertenece a
          una organizacion habilitada para MYKLUBB Control.
        </p>
        <button onClick={() => signOut()} className="rounded bg-primary text-primary-foreground px-4 py-2">
          Cerrar sesion
        </button>
      </div>
    </div>
  );
}
